import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import reportWebVitals from './reportWebVitals.ts'
import { sendToAnalytics } from './utils/metrics.ts'
import authLogger from './features/auth/services/authLogger.ts'

authLogger.log('bootstrap', 'exames boot snapshot', {
  cookies: authLogger.cookieSnapshot(),
  origin: window.location.origin,
  apiBaseURL: import.meta.env.VITE_APP_NEW_BACKEND_ENDPOINT,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

reportWebVitals(sendToAnalytics);